import React from "react";
import { boundaries, numberOne, rankings } from "../../mock";

const Boundaries = () => {
  return (
    <>
      {/* Parallax-ish banner */}
      <section id="excellence" className="relative h-[70vh] flex items-center justify-center overflow-hidden">
        <img src={boundaries.image} alt="Team" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/50" />
        <div className="relative text-center text-white px-6 reveal">
          <p className="text-[11px] tracking-luxe uppercase text-white/80 mb-6">{boundaries.eyebrow}</p>
          <h2 className="font-serif-display text-4xl md:text-6xl lg:text-7xl font-light leading-tight max-w-4xl mx-auto">
            {boundaries.title}
          </h2>
        </div>
      </section>

      {/* It all adds to #1 */}
      <section id="markets" className="bg-[#0d0d0d] text-white py-24 md:py-32">
        <div className="max-w-[1300px] mx-auto px-6 md:px-10">
          <div className="text-center mb-20 reveal">
            <p className="text-[11px] tracking-luxe uppercase text-[#b4936a] mb-4">Excellence Recognized</p>
            <h2 className="font-serif-display text-5xl md:text-7xl font-light">It all adds to Number One</h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-16">
            {numberOne.map((n, i) => (
              <div key={i} className="reveal">
                <h3 className="font-serif-display text-3xl mb-5 text-white">{n.title}</h3>
                <div className="w-12 h-px bg-[#b4936a] mb-5" />
                <p className="text-white/55 text-[14px] leading-relaxed">{n.body}</p>
              </div>
            ))}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-24 border-t border-white/15 pt-16">
            {rankings.map((r, i) => (
              <div key={i} className="text-center reveal">
                <h4 className="font-serif-display text-2xl md:text-3xl mb-4">{r.rank}</h4>
                <div className="w-8 h-px bg-white/30 mx-auto mb-4" />
                <p className="text-white/50 text-[12px] tracking-luxe-sm uppercase leading-relaxed">{r.sub}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Boundaries;
